import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const addMessage = async ({
  questionId,
  isHtml,
  message,
  companySignature,
}) => {
  const data = await request.post(
    `Question/add_note`,
    {
      questionId,
      isHtml,
      message,
      companySignature,
    },
    'Не удалось добавить сообщение',
    { id: null }
  );

  return data;
};

const useAddMessageMutation = (options) => {
  return useMutation(addMessage, options);
};

export default useAddMessageMutation;
